export default "__VITE_ASSET__5ea89ebe__"